//Accordion Catégories
$('.accordioncat .card').children().each(function(){
    if($(this).hasClass('show')) {
        $(this).prev().addClass('active');
    }
});

/*$(".accordioncat .card").hover(
    function() {
        var target = $(this).children('.card-header').attr('data-target').replace(/^#/, '');
        $(this).children('.card-header').removeClass('active');
        $('.accordioncat #'+target).collapse('show');
    }, function() {
        var target = $(this).children('.card-header').attr('data-target').replace(/^#/, '');
        $('.accordioncat #'+target).collapse('hide');
    }
);*/

$('.accordioncat .card-header[data-toggle="collapse"]').on('mouseenter', function() {
    $(this).parents('.card').find('.collapse').collapse('show');
});
//////////////////////////////////////////////
